import { baseUrl } from "../api";

export const tierDescriptionsUrl = `${baseUrl}tier-descriptions/`;
